import { ArrowUpRight, Mail, MapPin, Phone } from "lucide-react";

const TRACKS = [
  {
    code: "01",
    title: "Join as Strategic Partner",
    body: "For Italian and European luxury houses, manufacturing groups and technical partners seeking secured production capacity in Africa.",
    email: "lefikaragontse@lrgholdings.com",
    subject: "Strategic Partnership. LRG Leather Botswana",
    testid: "track-strategic-partner",
  },
  {
    code: "02",
    title: "Investor Access",
    body: "For institutional investors, family offices and strategic equity partners reviewing the LRG Leather Botswana SPV.",
    email: "lefikaragontse@lrgholdings.com",
    subject: "Investor Access. LRG Leather Botswana",
    testid: "track-investor-access",
    primary: true,
  },
  {
    code: "03",
    title: "Institutional & Government Partnerships",
    body: "For multilateral institutions, development finance bodies and government counterparts engaging on the SEZA-aligned framework.",
    email: "lefikaragontse@lrgholdings.com",
    subject: "Institutional Partnership. LRG Leather Botswana",
    testid: "track-institutional",
  },
];

export default function Contact() {
  return (
    <div data-testid="page-contact" className="bg-[#F9F9F6]">
      {/* Hero */}
      <section className="pt-32 md:pt-40 pb-12 md:pb-16 max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-12 gap-8">
          <div className="col-span-12 lg:col-span-9">
            <p className="eyebrow">04 / Contact</p>
            <h1
              data-testid="contact-headline"
              className="font-serif text-5xl sm:text-6xl md:text-7xl lg:text-[88px] leading-[0.95] tracking-tight mt-6 rise"
            >
              Engagement,
              <br />
              <span className="italic text-[#5C2018]">structured.</span>
            </h1>
            <p className="mt-8 text-base md:text-lg text-[#1A1A1A] max-w-2xl leading-relaxed">
              Three direct entry points. By role, not by form. Each route is
              monitored by the relevant team within LRG Holdings.
            </p>
          </div>
        </div>
      </section>

      {/* Tracks */}
      <section
        data-testid="contact-tracks"
        className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16 pb-16 md:pb-24"
      >
        <div className="grid grid-cols-1 md:grid-cols-3 border-l border-t border-[#1A1A1A]">
          {TRACKS.map((t) => (
            <a
              key={t.code}
              href={`mailto:${t.email}?subject=${encodeURIComponent(t.subject)}`}
              data-testid={`contact-${t.testid}`}
              className={`group border-r border-b border-[#1A1A1A] p-8 md:p-10 lg:p-12 flex flex-col transition-colors duration-300 ${
                t.primary
                  ? "bg-[#5C2018] text-[#F9F9F6] hover:bg-[#1A1A1A]"
                  : "bg-[#F9F9F6] text-[#1A1A1A] hover:bg-white"
              }`}
            >
              <div className="flex items-center justify-between">
                <span
                  className={`font-serif text-xl tracking-tight ${
                    t.primary ? "text-[#E5C4A1]" : "text-[#5C2018]"
                  }`}
                >
                  {t.code}
                </span>
                <ArrowUpRight
                  size={20}
                  className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1"
                />
              </div>
              <h3 className="font-serif text-2xl md:text-[28px] tracking-tight leading-tight mt-12 md:mt-16">
                {t.title}
              </h3>
              <p
                className={`mt-5 text-sm leading-relaxed ${
                  t.primary ? "text-[#E0D8CD]" : "text-[#1A1A1A]"
                }`}
              >
                {t.body}
              </p>
              <div className="mt-auto pt-12">
                <p
                  className={`text-[10px] uppercase tracking-[0.24em] ${
                    t.primary ? "text-[#E5C4A1]" : "text-[#666666]"
                  }`}
                >
                  Direct line
                </p>
                <p
                  className={`mt-2 text-base font-medium border-b inline-flex items-center gap-2 pb-1 ${
                    t.primary
                      ? "border-[#E5C4A1] text-[#F9F9F6]"
                      : "border-[#1A1A1A] text-[#1A1A1A]"
                  }`}
                >
                  <Mail size={14} />
                  {t.email}
                </p>
              </div>
            </a>
          ))}
        </div>
      </section>

      {/* Office strip */}
      <section className="bg-[#1A1A1A] text-[#F9F9F6]">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16 py-20 md:py-24">
          <div className="grid grid-cols-12 gap-8 md:gap-12">
            <div className="col-span-12 md:col-span-5">
              <p className="eyebrow text-[#A8A8A0]">Project Office</p>
              <h2 className="font-serif text-4xl md:text-5xl tracking-tight leading-tight mt-5">
                LRG Holdings .
                <br />
                <span className="italic text-[#E5C4A1]">Botswana Leather.</span>
              </h2>
            </div>
            <div className="col-span-12 md:col-span-3 md:col-start-7">
              <div className="flex items-start gap-3">
                <MapPin size={16} className="mt-1 text-[#E5C4A1]" />
                <div>
                  <p className="eyebrow text-[#A8A8A0]">Site</p>
                  <p className="font-serif text-lg mt-2 leading-snug">
                    Lobatse Special Economic Zone
                    <br />
                    Botswana
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3 mt-8">
                <Phone size={16} className="mt-1 text-[#E5C4A1]" />
                <div>
                  <p className="eyebrow text-[#A8A8A0]">By appointment</p>
                  <p className="font-serif text-lg mt-2">
                    Institutional briefings only
                  </p>
                </div>
              </div>
            </div>
            <div className="col-span-12 md:col-span-3">
              <p className="eyebrow text-[#A8A8A0]">General</p>
              <a
                href="mailto:lefikaragontse@lrgholdings.com"
                data-testid="contact-general-email"
                className="font-serif text-2xl mt-4 inline-flex items-center gap-2 border-b border-[#E5C4A1] pb-1 hover:text-[#E5C4A1] transition-colors"
              >
                lefikaragontse@lrgholdings.com
                <ArrowUpRight size={16} />
              </a>
              <p className="mt-6 text-xs text-[#A8A8A0] leading-relaxed">
                Please use a role-specific track above where possible .
                routing accelerates response times materially.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Closing line */}
      <section className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16 py-20 md:py-28">
        <div className="border-t border-[#1A1A1A] pt-10">
          <p className="font-serif text-2xl md:text-3xl tracking-tight max-w-3xl leading-snug">
            A structured, government-aligned industrial project. Already in
            motion. With a clear entry point for capital and partners.
          </p>
        </div>
      </section>
    </div>
  );
}
